<template>
    <div class="reminddetails-main">
      	<div class="banner-container">
			<p class="title PangMenZhengDao">{{$t("remiind.notice")}}</p>
			<p class="desc">
				{{$t("remiind.noticeDesc")}}
			</p>
		</div>
		<div class="sect-container">
			<div class="sec-item">
				<p class="lable">
					{{$t("remiind.noticeSect")}}:
				</p>
				<p class="value">{{msg}}</p>
			</div>
            <div class="submit-btn" @click="seePlan">
                {{$t("remiind.seeDiotherapy")}}
            </div>
		</div>
    </div>
</template>

<script>
import { radiotherapyMsg } from "@/api/user"
export default {
    data () {
        return {
            radiotherapyMsgUserId:this.$route.query.radiotherapyMsgUserId,
            msg:""
        }
    },
    created () {
        document.title = this.$t("remiind.radiotherapy")
        const toast = this.$Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: this.$t("message.loadingTxt")
        });
        radiotherapyMsg({radiotherapyMsgUserId:this.radiotherapyMsgUserId}).then(res =>{
            toast.clear();
            console.log(res);
            this.msg = res.data.data
        })
    },
    methods: {
        seePlan(){
            this.$router.push({
                path:"/radiotherapy/index"
            })
        }
    }
}
</script>

<style lang="less" scoped>
// .radiltherapy-msg{
//     height: 100%;
//     width: 100%;
//     background: #fff;
//     padding: 0.6rem;
//     overflow: auto;
//     box-sizing: border-box;
//     .title{
//         font-size: 0.8rem;
//         margin-bottom: 0.4rem;
//         text-align: center;
//         font-weight: 500;
//     }
//     .txt{
//         font-size: 0.72rem;
//         text-indent: 2em;
//     }
// }

@import url("~@/assets/iconfont/iconfont.css");
.reminddetails-main{
	min-height: 100vh;
	background-color: #F5F6FA;
	background-image: url("~@/assets/img/remind-back.png") ;
	background-size: 100% 7.8rem;
	background-repeat: no-repeat;
	// box-sizing: border-box;
	// padding: 0 0.6rem;
	.banner-container{
		height: 5.4rem;
		padding-left: 6.4rem;
		padding-top: 1.6rem;
		background-image: url("~@/assets/img/remind-back2.png");
		background-repeat: no-repeat;
		background-size: 6.3rem 4rem;
		background-position-y: 70%;
		box-sizing: border-box;
		.title{
			font-size: 1.25rem;
			font-family: "PangMenZhengDao";
			color: #FFFFFF;
			line-height: 1.52rem;
			letter-spacing: 0.24rem;
			font-weight: 500;
			-webkit-background-clip: text;
			// -webkit-text-fill-color: transparent;
		}
		.desc{
			font-size: 0.52rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			line-height: 0.74rem;
			margin-top: 0.15rem;
			letter-spacing: 0.15rem;
		}
	}
	.sect-container{
		margin: 0 0.6rem;
		padding: 0.8rem;
		background: #FFFFFF;
		// min-height: 8rem;
        // display: flex;
        // flex-direction: column;
		border-radius: 0.52rem;
		.sec-item{
            // flex: 1;
			margin-bottom: 0.5rem;
			.lable{
				font-size: 0.7rem;
				padding-left: 0.4rem;
				font-weight: bold;
				position: relative;
				&::after{
					position: absolute;
					content: ' ';
					height: 80%;
					width: 0.16rem;
					background: linear-gradient(180deg, #378BFD 0%, #88C5FD 100%);
					border-radius: 0.08rem;
					left: 0;
					top: 50%;
					transform: translate(0,-40%);
				}
			}
			.value{
				font-size: 0.7rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				margin-top: 0.1rem;
			}
		}
        .submit-btn{
            width: 100%;
            margin: 2rem auto 1rem auto;
            color: #fff;
            height: 2rem;
            background: linear-gradient(0deg, #0095FF 0%, #6EC9FF 100%);
            border-radius: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.76rem;
            font-family: PingFang SC;
            font-weight: 500;
        }
	}

// remind-back2.png
// 
}
</style>